import { format } from 'date-fns';

import { getPrinters } from '@legacy-services/printer';

type Period = App.Domain.Event.Data.PeriodData;

interface PrinterSettings {
  [periodId: number]: {
    [day: string]: string;
  };
}

type Printer = {
  name: string;
} & unknown;

export async function getPrinterForDayPeriod(day: string, period: Period, settings: PrinterSettings): Promise<Printer> {
  if (!settings[period.id]?.[day]) {
    throw new Error(
      `Printer not set for ${
        day === 'combi' ? day : format(new Date(day), 'EEE dd/MM')
      } ${period.name}, please check printers page.`
    );
  }

  const printerName = settings[period.id][day];
  const response = await getPrinters();

  if (!response.printer) {
    throw new Error('No Printers connected, please check printers page.');
  }

  const printer = response.printer.find((p: Printer) => p.name === printerName);

  if (!printer) {
    throw new Error('Printer not connected, please check printers page.');
  }

  return printer;
}
